import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateFormat } from '../../interfaces/base-core-services.interface';
import { IGenericFormLoader } from '../../interfaces/form-label';
import { DateTimeService } from '../../services/date-time.service';
import { differenceInCalendarDays } from 'date-fns';
@Component({
  selector: 'app-visa-details',
  templateUrl: './visa-details.component.html',
  styleUrls: ['./visa-details.component.less']
})
export class VisaDetailsComponent implements OnInit, IGenericFormLoader {
  @Input() public defaultFormData: string[];
  @Output() public submitedFormData = new EventEmitter<FormData>();
  public type: any[] = [];
  public durationGroup: FormGroup;
  public endDate : Date | null = null;
  public duration: any[] = [];
  public startDate : Date | null = null;
  public formData:any = { 'variables': {} };
  public load = false;
  public endOpen = false;
  constructor(private formBuilder: FormBuilder,  private dataTimeService: DateTimeService) { }

  ngOnInit():void {
    if (typeof this.defaultFormData === 'object') {
      this.onLoad(this.defaultFormData);
      this.load = true;
    }
  }

  disabledStartDate = (current: Date): boolean => {
    const today = new Date();
    return differenceInCalendarDays(today, current) > 0;
  };

  disabledEndDate = (endDate: Date): boolean => {
    const daysDiasabled = 30;
    if (!endDate || !this.startDate) {
      return false;
    }
    return endDate.getTime() < this.startDate.getTime() + (daysDiasabled * (3600000 * 24));
  };

  onStartChange(date: Date): void {
    this.startDate = date;
    this.endDate = null;
  }

  onEndChange(date: Date): void {
    this.endDate = date;
  }

  handleStartOpenChange(open: boolean): void {
    if (!open) {
      this.endOpen = true;
    }
  }

  handleEndOpenChange(open: boolean): void {

    this.endOpen = open;
  }


  onLoad(data:any):void {
    this.durationGroup = this.formBuilder.group({
      startDate: [null, [Validators.required]],
      endDate: [null, [Validators.required]],
      duration: [null, [Validators.required]],
      type: [null, [Validators.required]],
      visaNumber: [null, [Validators.required]],
      comments:[null]
    });

    const keys = Object.keys(data.rdmData);
    keys.forEach((key) => {
      if (key.indexOf('wfm.visa.type') >= 0) {
        this.type = data.rdmData[key];

      }
      if (key.indexOf('wfm.visa.duration') >= 0) {
        this.duration = data.rdmData[key];
      }
    });

  }

  onSubmit():void {
    for (const i in this.durationGroup.controls) {
      if(i in this.durationGroup.controls){
        this.durationGroup.controls[i].markAsDirty();
        this.durationGroup.controls[i].updateValueAndValidity();
      }
    }

    if (this.durationGroup.value.duration !== null) {
      this.formData.variables['duration'] = { 'value': this.durationGroup.value.duration };
    }


    if (this.durationGroup.value.startDate !== null) {
      this.formData.variables['startDate'] = { 'value':  this.dataTimeService.getDateFormat(this.durationGroup.value.startDate.getTime(), DateFormat.DATE_TIMEZONE)  };
    }

    if (this.durationGroup.value.endDate !== null) {
      this.formData.variables['endDate'] = { 'value': this.dataTimeService.getDateFormat(this.durationGroup.value.endDate.getTime(), DateFormat.DATE_TIMEZONE) };
    }

    if (this.durationGroup.value.type !== null) {
      this.formData.variables['type'] = { 'value': this.durationGroup.value.type };
    }

    if (this.durationGroup.value.visaNumber !== null) {
      this.formData.variables['visaNumber'] = { 'value': this.durationGroup.value.visaNumber };
    }

    if (this.durationGroup.value.visaNumber !== null) {
      this.formData.variables['comments'] = { 'value': this.durationGroup.value.comments };
    }

    if (this.durationGroup.valid) {
      this.submitedFormData.emit(this.formData);
    }

  }
}
